var ezdia;
(function (ezdia) {
    var NAME = 'history';
    var TYPE = 'ez.history';
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var FETCH_HISTORY_LIST_URL = 'fetchContentHistoryList.htm';
    var FETCH_HISTORY_CONTENT_URL = 'fetchHistoricalContent.htm';
    var ID_PREFIX = ezdia.config.IDS.PREFIX;
    var SHOW_HISTORY_WRAP_ID_PREFIX = ID_PREFIX + "show-history-wrap__";
    var SHOW_HISTORY_CLS = 'history-compare-show';
    var TEMPLATES = ezdia.templates.history;
    var CONTENT_ACTIONS_TYPE = {
        compare: 'compare',
        revert: 'revert',
        close: 'close'
    };
    var Default = {
        column: null,
        id: null,
        idSuffix: null,
        value: null,
        selectedId: null
    };
    var History = /** @class */ (function () {
        function History(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(History, "Default", {
            get: function () {
                return Default;
            },
            enumerable: false,
            configurable: true
        });
        History.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, Default), this.$elem.data()), options);
        };
        History.prototype.init = function (options) {
            this.type = TYPE;
            this.$elem = $(this.elem);
            this.id = this.elem.id;
            this.options = this.getOptions(options);
            this.render();
        };
        History.prototype.render = function () {
            this.$wrapper = this.renderWrapper();
            this.$elem.on("click." + TYPE, this.handelOnClick.bind(this));
        };
        History.prototype.renderWrapper = function () {
            var idSuffix = this.options.idSuffix;
            var idString = "" + SHOW_HISTORY_WRAP_ID_PREFIX + idSuffix;
            var htmlWrapperContent = TEMPLATES.container(idString);
            this.$elem.parent().before(htmlWrapperContent);
            return $("#" + idString);
        };
        History.prototype.renderListItems = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, success, response, responseText, htmlContent, formatedItems;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.fetchList()];
                        case 1:
                            _a = _b.sent(), success = _a.success, response = _a.response, responseText = _a.responseText;
                            htmlContent = '';
                            if (!success) {
                                htmlContent = TEMPLATES.errorContent(responseText);
                            }
                            else if (!response.length) {
                                htmlContent = TEMPLATES.emptyContent();
                            }
                            else {
                                formatedItems = this.formatListData(response);
                                htmlContent = TEMPLATES.listItemsContent(formatedItems);
                            }
                            this.$wrapper.html(htmlContent);
                            this.bindOnClickHistoryItems();
                            return [2 /*return*/];
                    }
                });
            });
        };
        History.prototype.renderListContent = function ($elem) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, itemId, itemTaskid, listData, elemId, id, jsContentID, itemObject, htmlContent, contentWrapper;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = $elem.data(), itemId = _a.itemId, itemTaskid = _a.itemTaskid;
                            return [4 /*yield*/, this.fetchListItemContent(itemId, itemTaskid)];
                        case 1:
                            listData = _b.sent();
                            elemId = this.options.id;
                            if (listData) {
                                id = listData.id;
                                jsContentID = elemId + "sh__" + id;
                                itemObject = __assign({ jsContentID: jsContentID }, listData);
                                htmlContent = TEMPLATES.itemContent(itemObject);
                                contentWrapper = $elem.next();
                                contentWrapper.html(htmlContent);
                                this.bindContentAction(itemObject, contentWrapper);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        History.prototype.compareContent = function (itemObject) {
            var contentOld = itemObject.contentOld, jsContentID = itemObject.jsContentID;
            var content = this.getContentDiff(contentOld);
            $("#" + jsContentID).html(content);
        };
        History.prototype.getContentDiff = function (oldContent) {
            var contentOld = oldContent;
            // eslint-disable-next-line no-undef
            var dmp = new diff_match_patch();
            var _a = this.options.column, edittype = _a.edittype, fieldID = _a.id;
            var contentNew = '';
            var id;
            if (edittype === 'html') {
                id = tinymce.get(fieldID);
                contentNew = id.getContent();
            }
            else if (edittype === 'status') {
                id = $("#" + fieldID + "-status");
                contentNew = id.val();
            }
            else {
                id = $("#" + fieldID);
                contentNew = id.val();
            }
            var regex = '<s*/[A-Za-zs]*?>';
            var re = new RegExp(regex, 'ig');
            contentOld = contentOld.replace(re, '\n');
            contentNew = contentNew.replace(re, '\n');
            var content = dmp.diff_main(this.stripHTML(contentOld), this.stripHTML(contentNew));
            dmp.diff_cleanupEfficiency(content);
            content = dmp.diff_prettyHtml(content);
            content = content.replace(/&para;/g, '');
            return content;
        };
        History.prototype.stripHTML = function (html) {
            var tmp = document.createElement('DIV');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        };
        History.prototype.revertContent = function (itemObject) {
            var contentOld = itemObject.contentOld;
            var _a = this.options.column, edittype = _a.edittype, id = _a.id;
            if (edittype === 'html') {
                var ed = tinymce.get(id);
                ed.setContent(contentOld);
            }
            else if (edittype === 'slider') {
                $("#" + id).bootstrapSlider('setValue', +contentOld);
                setSliderValue(id, contentOld);
            }
            else if (edittype === 'status') {
                $("#" + id + "-status").val(contentOld);
            }
            else {
                $("#" + id).val(contentOld);
            }
        };
        History.prototype.closeContent = function ($elem) {
            var wrapper = $elem
                .closest('[data-container-type="history compare"]')
                .empty();
            wrapper.prev().removeClass(SHOW_HISTORY_CLS);
        };
        History.prototype.bindOnClickHistoryItems = function () {
            this.$wrapper
                .find('[data-item-id]')
                .on("click." + TYPE, this.handelOnClickHistoryItem.bind(this));
        };
        History.prototype.bindContentAction = function (itemObject, contentWrapper) {
            contentWrapper
                .find('button[data-btn-type]')
                .on("click." + TYPE, this.handelOnClickOnContentActionsBtns.bind(this, itemObject));
        };
        History.prototype.handelOnClick = function () {
            this.renderListItems();
        };
        History.prototype.handelOnClickHistoryItem = function (event) {
            var currentTarget = event.currentTarget;
            var elem = $(currentTarget);
            var itemId = elem.data().itemId;
            if (itemId) {
                elem.addClass(SHOW_HISTORY_CLS);
                this.renderListContent(elem);
            }
        };
        History.prototype.handelOnClickOnContentActionsBtns = function (itemObject, event) {
            var currentTarget = event.currentTarget;
            var $elem = $(currentTarget);
            var btnType = $elem.data().btnType;
            if (btnType === CONTENT_ACTIONS_TYPE.compare) {
                this.compareContent(itemObject);
            }
            else if (btnType === CONTENT_ACTIONS_TYPE.revert) {
                this.revertContent(itemObject);
            }
            else {
                this.closeContent($elem);
            }
        };
        History.prototype.formatListData = function (listItems) {
            var e_1, _a;
            var index = 0;
            var formatedItems = [];
            try {
                for (var listItems_1 = __values(listItems), listItems_1_1 = listItems_1.next(); !listItems_1_1.done; listItems_1_1 = listItems_1.next()) {
                    var item = listItems_1_1.value;
                    if (index === 0) {
                        formatedItems.push(__assign(__assign({}, item), { id: null, taskId: null }));
                    }
                    index += 1;
                    var nextitem = listItems[index];
                    if (nextitem) {
                        var createdOn = nextitem.createdOn, lastModifiedByRole = nextitem.lastModifiedByRole;
                        formatedItems.push(__assign(__assign({}, item), { createdOn: createdOn,
                            lastModifiedByRole: lastModifiedByRole }));
                    }
                    else {
                        formatedItems.push(__assign({}, item));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (listItems_1_1 && !listItems_1_1.done && (_a = listItems_1.return)) _a.call(listItems_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return formatedItems;
        };
        History.prototype.fetchList = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, accountName, role, _b, selectedId, fieldName, reqData, response, ex_1, responseText;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = $.ezdia.config.pageParams, accountName = _a.account, role = _a.role;
                            _b = this.options, selectedId = _b.selectedId, fieldName = _b.column.name;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            reqData = {
                                accountName: accountName,
                                role: role,
                                taskId: selectedId,
                                fieldName: fieldName
                            };
                            return [4 /*yield*/, this.fetch({
                                    url: FETCH_HISTORY_LIST_URL,
                                    reqData: reqData
                                })];
                        case 2:
                            response = _c.sent();
                            return [2 /*return*/, {
                                    success: true,
                                    response: response
                                }];
                        case 3:
                            ex_1 = _c.sent();
                            responseText = ex_1.responseText;
                            return [2 /*return*/, {
                                    success: false,
                                    responseText: responseText
                                }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        History.prototype.fetchListItemContent = function (itemId, itemTaskid) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, accountName, role, fieldName, reqData, response, ex_2, responseText;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = $.ezdia.config.pageParams, accountName = _a.account, role = _a.role;
                            fieldName = this.options.column.name;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            reqData = {
                                accountName: accountName,
                                role: role,
                                fieldName: fieldName,
                                historyId: itemId,
                                taskId: itemTaskid
                            };
                            return [4 /*yield*/, this.fetch({
                                    url: FETCH_HISTORY_CONTENT_URL,
                                    reqData: reqData
                                })];
                        case 2:
                            response = _b.sent();
                            return [2 /*return*/, response];
                        case 3:
                            ex_2 = _b.sent();
                            responseText = ex_2.responseText;
                            ezdia.util.showSuccessError({
                                autohide: false,
                                error: true,
                                message: responseText
                            });
                            return [2 /*return*/, null];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        History.prototype.fetch = function (_a) {
            var reqData = _a.reqData, url = _a.url;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            $.ajax({
                                type: 'POST',
                                url: url,
                                data: reqData,
                                dataType: 'json',
                                success: resolve,
                                error: reject
                            });
                        })];
                });
            });
        };
        return History;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {};
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(TYPE);
        if (inputObject && inputObject instanceof History) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(TYPE);
            var options = typeof option === 'object' && option;
            if (typeof option === 'string') {
                data[option]();
            }
            else {
                if (data) {
                    data.destroy();
                }
                self.data(TYPE, (data = new History(this, options)));
                var attrId = self.attr('id');
                $.ezdia.widgetsInstance.add('isDirty', attrId, self, 'destroy');
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = History;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
